var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWellness({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_25048_20883",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_25048_20883)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.66667 16.6654C5.25 16.6654 4.89583 16.5195 4.60417 16.2279C4.3125 15.9362 4.16667 15.582 4.16667 15.1654C4.16667 14.8737 4.25 14.5994 4.41667 14.3424C4.58333 14.0855 4.80556 13.9015 5.08333 13.7904L8.33333 12.4987V10.6237C7.58333 11.4987 6.71181 12.1688 5.71875 12.6341C4.72569 13.0994 3.65278 13.332 2.5 13.332V11.6654C3.44444 11.6654 4.30208 11.4709 5.07292 11.082C5.84375 10.6931 6.54167 10.1376 7.16667 9.41536L8.29167 8.08203C8.45833 7.88759 8.65278 7.74175 8.875 7.64453C9.09722 7.54731 9.33333 7.4987 9.58333 7.4987H10.4167C10.6667 7.4987 10.9028 7.54731 11.125 7.64453C11.3472 7.74175 11.5417 7.88759 11.7083 8.08203L12.8333 9.41536C13.4583 10.1376 14.1562 10.6931 14.9271 11.082C15.6979 11.4709 16.5556 11.6654 17.5 11.6654V13.332C16.3472 13.332 15.2743 13.0994 14.2812 12.6341C13.2882 12.1688 12.4167 11.4987 11.6667 10.6237V12.4987L14.9167 13.7904C15.1944 13.9015 15.4167 14.0855 15.5833 14.3424C15.75 14.5994 15.8333 14.8737 15.8333 15.1654C15.8333 15.582 15.6875 15.9362 15.3958 16.2279C15.1042 16.5195 14.75 16.6654 14.3333 16.6654H8.33333V16.2487C8.33333 15.8876 8.45139 15.589 8.6875 15.3529C8.92361 15.1168 9.22222 14.9987 9.58333 14.9987H12.0833C12.2083 14.9987 12.309 14.9605 12.3854 14.8841C12.4618 14.8077 12.5 14.707 12.5 14.582C12.5 14.457 12.4618 14.3563 12.3854 14.2799C12.309 14.2036 12.2083 14.1654 12.0833 14.1654H9.58333C9 14.1654 8.50694 14.3668 8.10417 14.7695C7.70139 15.1723 7.5 15.6654 7.5 16.2487V16.6654H5.66667ZM10 6.66536C9.54167 6.66536 9.14931 6.50217 8.82292 6.17578C8.49653 5.84939 8.33333 5.45703 8.33333 4.9987C8.33333 4.54036 8.49653 4.148 8.82292 3.82161C9.14931 3.49523 9.54167 3.33203 10 3.33203C10.4583 3.33203 10.8507 3.49523 11.1771 3.82161C11.5035 4.148 11.6667 4.54036 11.6667 4.9987C11.6667 5.45703 11.5035 5.84939 11.1771 6.17578C10.8507 6.50217 10.4583 6.66536 10 6.66536Z",
    fill: "#74788D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWellness);
export default __webpack_public_path__ + "static/media/wellness.072ee6c1750b3f66c70371fcd713d646.svg";
export { ForwardRef as ReactComponent };